<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("edit") }} {{ $tc("cinema", 2) }}
      </div>
      <router-link class="btn-blue" to="cinemas"
        >{{ $tc("cinema", 2) }} {{ $tc("list", 2) }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <form class="row">
        <section v-if="true" class="mb-4 w-100 px-3 section-new">
          <div
            class="section-title mb-3 d-flex justify-content-between section-collapse-box new-border"
            style="padding: 6px; align-items: center; border-radius: 10px"
            v-b-toggle.cinemadetails
          >
            <span class="fs">
              {{ $tc("Cinema Details", 2) }}
            </span>
            <button type="button" class="btn-transparent chevron">
              <img
                src="@/assets/img/icons/primary/chevron-down.svg"
                height="24"
                width="24"
              />
            </button>
          </div>
          <b-collapse
            id="cinemadetails"
            class="mt-2"
            v-model="sectionCollapse.cinemadetails"
          >
            <div
              class="row pr-2 pl-2 pt-3 pb-2 new-border br-10 mx-auto back"
              style="border-radius: 10px"
            >
              <div
                v-for="(item, index) in Cinemas"
                :key="index"
                v-if="item.fieldname !== 'cine_id'"
                class="col-lg-4 col-xl-3 align-self-center mb-4"
              >
                <div
                  v-if="
                    item.type !== 'radio' &&
                      item.type !== 'dropdown' &&
                      item.type !== 'file'
                  "
                >
                  <div class="d-flex align-items-center">
                    <div class="input-material d-flex align-items-center">
                      <div
                        v-if="item.fieldname === 'cine_phone'"
                        class="col-4 pl-0"
                      >
                        <!--  -->
                        <b-dropdown
                          :text="SelectedCountryCode"
                          variant="dropdown-curve"
                          class="w-100 text-center mr-3"
                          placeholder="code"
                          name="countrycode"
                          id="countrycode"
                        >
                          <div class="px-2 pb-2">
                            <input
                              required
                              autofocus
                              type="search"
                              placeholder="Search Code"
                              class="form-control form-control-sm"
                              v-on:keyup="onSearchCode($event.target.value)"
                              v-on:keydown="onSearchCode($event.target.value)"
                              v-on:search="onSearchCode($event.target.value)"
                              v-model="searchCode"
                            />
                          </div>
                          <b-dropdown-item
                            href="#"
                            v-for="(countrycode, countryIndex) in countryList"
                            :key="countryIndex"
                            v-on:click="
                              onSelectHandler('countrycode', countrycode)
                            "
                            v-if="countrycode.country_mob_code != null"
                            >{{ countrycode.country_mob_code }}</b-dropdown-item
                          >
                        </b-dropdown>
                        <!--  -->
                      </div>
                      <div class="position-relative w-100">
                        <input
                          @focus="onFocusHandler"
                          :type="item.type"
                          :name="item.fieldname"
                          :id="item.fieldname"
                          v-validate="item.validation"
                          v-model="item.fieldvalue"
                          placeholder="."
                        />
                        <label>{{ $tc(item.label, 1) }}</label>
                      </div>
                    </div>
                    <!-- <Tooltip :title="$t(item.tooltip)" /> -->
                  </div>
                  <p class="error_message">
                    <span v-if="submitted && errors.has(item.fieldname)">{{
                      errors.first(`${item.fieldname}`)
                    }}</span>
                  </p>
                </div>

                <div v-if="item.type === 'radio'">
                  <div
                    v-if="item.fieldname === 'cine_is_active'"
                    class="d-flex align-items-center"
                  >
                    <label class="mb-0 mr-3">{{ $t("active") }}</label>
                    <b-form-checkbox
                      type="checkbox"
                      class="j-checkbox mb-0 ml-2"
                      v-model="item.fieldvalue"
                    />
                  </div>
                </div>

                <div
                  v-if="
                    item.type === 'file' && item.fieldname === 'cine_image_url'
                  "
                >
                  <div class="d-flex align-items-center">
                    <label :for="item.fieldname" class="file-selector w-100">
                      <label
                        class="file-selector-label"
                        :class="
                          item.fieldvalue && item.fieldvalue.length > 0
                            ? 'shift-up'
                            : ''
                        "
                        >{{ $tc(item.label, 1) }}</label
                      >
                      <span class="text-truncate">{{ item.fieldvalue }}</span>
                      <input
                        :type="item.type"
                        :name="item.fieldname"
                        :id="item.fieldname"
                        placeholder="."
                        class="d-none"
                        v-on:change="setImage($event, index)"
                      />
                    </label>
                    <div class="col-2 align-self-center">
                      <img
                        width="40"
                        height="40"
                        class="rounded"
                        @click="showImage()"
                        :src="_GetImagePath(item.fieldvalue)"
                        v-if="item.fieldvalue && item.fieldvalue.length > 0"
                      />
                      <img
                        v-else
                        width="35"
                        height="35"
                        class="rounded"
                        alt="Empty Image"
                        src="@/assets/img/icons/empty-image.svg"
                      />
                    </div>

                    <!-- <Tooltip :title="$t(item.tooltip)" /> -->
                  </div>
                  <p class="error_message">
                    <span
                      v-if="
                        submitted &&
                          item.fieldvalue &&
                          item.fieldvalue.length == 0
                      "
                      >Please upload an image.</span
                    >
                  </p>
                </div>

                <div v-if="item.type === 'dropdown'" class>
                  <div v-if="item.fieldname === 'org_id'">
                    <div class="dropdown-curve-container">
                      <label class="shift-up">{{ $tc(item.label, 1) }}</label>
                      <b-dropdown
                        :text="item.dropdownSelected"
                        variant="dropdown-curve"
                        class="w-100"
                        name="org"
                        id="org"
                      >
                        <b-dropdown-item
                          v-for="(dropdownItem, dropdownIndex) in orgList"
                          :key="dropdownIndex"
                          href="#"
                          @click="
                            onDropdownChange(
                              $event,
                              item.label,
                              dropdownItem,
                              index
                            )
                          "
                          >{{ dropdownItem.org_name }}</b-dropdown-item
                        >
                      </b-dropdown>
                    </div>
                    <p class="error_msg">
                      <span
                        v-if="submitted && item.dropdownSelected.length == 0"
                        >Please Select Organization.</span
                      >
                    </p>
                  </div>

                  <!-- CINEMA TYPE DROPDOWN -->
                  <div
                    class="dropdown-curve-container"
                    v-if="item.fieldname === 'cinema_type_id'"
                  >
                    <div
                      class="d-flex justify-content-center align-items-center"
                    >
                      <label
                        :class="
                          item.dropdownSelected &&
                          item.dropdownSelected.length > 0
                            ? 'shift-up'
                            : ''
                        "
                        >{{ $tc(item.label, 1) }}</label
                      >
                      <b-dropdown
                        :text="item.dropdownSelected"
                        variant="dropdown-curve"
                        class="w-100"
                        name="cinema_type"
                        id="cinema_type"
                      >
                        <!-- _getCountryList(item.label, null) -->
                        <b-dropdown-item
                          v-for="(dropdownItem,
                          dropdownIndex) in cinemaTypesList"
                          :key="dropdownIndex"
                          @click="
                            onDropdownChange(
                              $event,
                              item.label,
                              dropdownItem,
                              index
                            )
                          "
                          >{{ dropdownItem.cinema_type_name }}</b-dropdown-item
                        >
                      </b-dropdown>
                      <!-- <Tooltip :title="$t(item.tooltip)" /> -->
                    </div>
                    <p class="error_message">
                      <!-- <span
                  v-if="submitted && item.dropdownSelected.length == 0"
                >Please Select Cinema Type.</span>-->
                    </p>
                  </div>

                  <div
                    class="dropdown-curve-container"
                    v-if="item.fieldname === 'currency_id'"
                  >
                    <div
                      class="d-flex justify-content-center align-items-center"
                    >
                      <label
                        :class="
                          item.dropdownSelected &&
                          item.dropdownSelected.length > 0
                            ? 'shift-up'
                            : ''
                        "
                        >{{ $tc(item.label, 1) }}</label
                      >
                      <b-dropdown
                        :text="item.dropdownSelected"
                        variant="dropdown-curve"
                        class="w-100"
                        name="curr"
                        id="curr"
                      >
                        <!-- _getCountryList(item.label, null) -->
                        <b-dropdown-item
                          v-for="(dropdownItem, dropdownIndex) in currencyList"
                          :key="dropdownIndex"
                          @click="
                            onDropdownChange(
                              $event,
                              item.label,
                              dropdownItem,
                              index
                            )
                          "
                          >{{ dropdownItem.curr_code }}</b-dropdown-item
                        >
                      </b-dropdown>
                      <!-- <Tooltip :title="$t(item.tooltip)" /> -->
                    </div>
                    <p class="error_message">
                      <span
                        v-if="submitted && item.dropdownSelected.length == 0"
                        >Please Select Currency.</span
                      >
                    </p>
                  </div>

                  <div
                    class="dropdown-curve-container"
                    v-if="item.fieldname === 'country_id'"
                  >
                    <div
                      class="d-flex justify-content-center align-items-center"
                    >
                      <label
                        :class="
                          item.dropdownSelected &&
                          item.dropdownSelected.length > 0
                            ? 'shift-up'
                            : ''
                        "
                        >{{ $tc(item.label, 1) }}</label
                      >
                      <!-- <b-dropdown
                  :text="item.dropdownSelected"
                  variant="dropdown-curve"
                  class="w-100"
                  name="coun"
                  id="coun"
                >
                  <b-dropdown-item
                    v-for="(dropdownItem,dropdownIndex) in countryList"
                    :key="dropdownIndex"
                    @click="onDropdownChange($event, item.label, dropdownItem, index)"
                  >{{ dropdownItem.country_name }}</b-dropdown-item>
                </b-dropdown>-->
                      <multiselect
                        :options="countryList"
                        v-model="selected_country"
                        :searchable="true"
                        label="country_name"
                        track-by="country_name"
                        placeholder="."
                        @input="
                          onDropdownChange(
                            $event,
                            item.label,
                            selected_country,
                            index
                          )
                        "
                        :allowEmpty="false"
                        :showLabels="false"
                      ></multiselect>
                      <!-- <Tooltip :title="$t(item.tooltip)" /> -->
                    </div>
                    <p class="error_message">
                      <span
                        v-if="submitted && item.dropdownSelected.length == 0"
                        >Please Select Country.</span
                      >
                    </p>
                  </div>

                  <div
                    class="dropdown-curve-container"
                    v-if="item.fieldname === 'state_id'"
                  >
                    <div
                      class="d-flex justify-content-center align-items-center"
                    >
                      <label :class="!!item.fieldvalue ? 'shift-up' : ''">{{
                        $tc(item.label, 1)
                      }}</label>
                      <!-- <b-dropdown
                  :text="item.dropdownSelected"
                  variant="dropdown-curve"
                  class="w-100"
                  name="state"
                  id="state"
                >

                  <b-dropdown-item
                    v-for="(dropdownItem,dropdownIndex) in stateList"
                    :key="dropdownIndex"
                    @click="onDropdownChange($event, item.label,dropdownItem, index)"
                  >{{ dropdownItem.state_name }}</b-dropdown-item>
                </b-dropdown>-->
                      <multiselect
                        :options="stateList"
                        v-model="selected_state"
                        :searchable="true"
                        label="state_name"
                        track-by="state_name"
                        placeholder="."
                        :allowEmpty="false"
                        :showLabels="false"
                        @input="
                          onDropdownChange(
                            $event,
                            item.label,
                            selected_state,
                            index
                          )
                        "
                      ></multiselect>
                      <!-- <Tooltip :title="$t(item.tooltip)" /> -->
                    </div>
                    <p class="error_message">
                      <span v-if="submitted && item.fieldvalue == ''"
                        >Please Select State.</span
                      >
                    </p>
                  </div>

                  <div
                    class="dropdown-curve-container"
                    v-if="item.fieldname === 'city_id'"
                  >
                    <div
                      class="d-flex justify-content-center align-items-center"
                    >
                      <label :class="!!item.fieldvalue ? 'shift-up' : ''">{{
                        $tc(item.label, 1)
                      }}</label>
                      <!-- <b-dropdown
                  :text="item.dropdownSelected"
                  variant="dropdown-curve"
                  class="w-100"
                  name="city"
                  id="city"
                >

                  <b-dropdown-item
                    v-for="(dropdownItem,dropdownIndex) in cityList"
                    :key="dropdownIndex"
                    @click="onDropdownChange($event, item.label,dropdownItem, index)"
                  >{{ dropdownItem.city_name }}</b-dropdown-item>
                </b-dropdown>-->
                      <multiselect
                        :options="cityList"
                        v-model="selected_city"
                        :searchable="true"
                        label="city_name"
                        track-by="city_name"
                        placeholder="."
                        :allowEmpty="false"
                        :showLabels="false"
                        @input="
                          onDropdownChange(
                            $event,
                            item.label,
                            selected_city,
                            index
                          )
                        "
                      ></multiselect>
                      <!-- <Tooltip :title="$t(item.tooltip)" /> -->
                    </div>
                    <p class="error_message">
                      <span v-if="submitted && item.fieldvalue == ''"
                        >Please Select City.</span
                      >
                    </p>
                  </div>

                  <!-- TERRITORY DROPDOWN -->
                  <div
                    class="dropdown-curve-container"
                    v-if="item.fieldname === 'territory_id'"
                  >
                    <div
                      class="d-flex justify-content-center align-items-center"
                    >
                      <label
                        :class="
                          item.dropdownSelected &&
                          item.dropdownSelected.length > 0
                            ? 'shift-up'
                            : ''
                        "
                        >{{ $tc(item.label, 1) }}</label
                      >
                      <b-dropdown
                        :text="item.dropdownSelected"
                        variant="dropdown-curve"
                        class="w-100"
                        name="territory"
                        id="territory"
                      >
                        <!-- _getCountryList(item.label, null) -->
                        <b-dropdown-item
                          v-for="(dropdownItem, dropdownIndex) in territoryList"
                          :key="dropdownIndex"
                          @click="
                            onDropdownChange(
                              $event,
                              item.label,
                              dropdownItem,
                              index
                            )
                          "
                          >{{ dropdownItem.territory_name }}</b-dropdown-item
                        >
                      </b-dropdown>
                      <!-- <Tooltip :title="$t(item.tooltip)" /> -->
                    </div>
                    <p class="error_message">
                      <!-- <span v-if="submitted && item.dropdownSelected.length == 0">Please Select Territory.</span> -->
                    </p>
                  </div>

                  <!-- REGION DROPDOWN -->
                  <div
                    class="dropdown-curve-container"
                    v-if="item.fieldname === 'region_id'"
                  >
                    <div
                      class="d-flex justify-content-center align-items-center"
                    >
                      <label
                        :class="
                          item.dropdownSelected &&
                          item.dropdownSelected.length > 0
                            ? 'shift-up'
                            : ''
                        "
                        >{{ $tc(item.label, 1) }}</label
                      >
                      <b-dropdown
                        :text="item.dropdownSelected"
                        variant="dropdown-curve"
                        class="w-100"
                        name="region"
                        id="region"
                      >
                        <!-- _getCountryList(item.label, null) -->
                        <b-dropdown-item
                          v-for="(dropdownItem, dropdownIndex) in regionList"
                          :key="dropdownIndex"
                          @click="
                            onDropdownChange(
                              $event,
                              item.label,
                              dropdownItem,
                              index
                            )
                          "
                          >{{ dropdownItem.region_name }}</b-dropdown-item
                        >
                      </b-dropdown>
                      <!-- <Tooltip :title="$t(item.tooltip)" /> -->
                    </div>
                    <p class="error_message">
                      <!-- <span v-if="submitted && item.dropdownSelected.length == 0">Please Select Region.</span> -->
                    </p>
                  </div>

                  <!-- LOCATION TYPE DROPDOWN -->
                  <div
                    class="dropdown-curve-container"
                    v-if="item.fieldname === 'location_type_id'"
                  >
                    <div
                      class="d-flex justify-content-center align-items-center"
                    >
                      <label
                        :class="
                          item.dropdownSelected &&
                          item.dropdownSelected.length > 0
                            ? 'shift-up'
                            : ''
                        "
                        >{{ $tc(item.label, 1) }}</label
                      >
                      <b-dropdown
                        :text="item.dropdownSelected"
                        variant="dropdown-curve"
                        class="w-100"
                        name="region"
                        id="region"
                      >
                        <!-- _getCountryList(item.label, null) -->
                        <b-dropdown-item
                          v-for="(dropdownItem,
                          dropdownIndex) in locationTypesList"
                          :key="dropdownIndex"
                          @click="
                            onDropdownChange(
                              $event,
                              item.label,
                              dropdownItem,
                              index
                            )
                          "
                          >{{
                            dropdownItem.location_type_name
                          }}</b-dropdown-item
                        >
                      </b-dropdown>
                      <!-- <Tooltip :title="$t(item.tooltip)" /> -->
                    </div>
                    <p class="error_message">
                      <!-- <span
                  v-if="submitted && item.dropdownSelected.length == 0"
                >Please Select Location Type.</span>-->
                    </p>
                  </div>
                </div>
                <!-- CINEMA CLASSIFICATION DROPDOWN -->
                <div
                  class="dropdown-curve-container"
                  v-if="item.fieldname === 'cinema_classification_id'"
                >
                  <div class="d-flex justify-content-center align-items-center">
                    <label
                      :class="
                        item.dropdownSelected &&
                        item.dropdownSelected.length > 0
                          ? 'shift-up'
                          : ''
                      "
                      >{{ $tc(item.label, 1) }}</label
                    >
                    <b-dropdown
                      :text="item.dropdownSelected"
                      variant="dropdown-curve"
                      class="w-100"
                      name="cinema_classification"
                      id="cinema_classification"
                    >
                      <b-dropdown-item
                        v-for="(dropdownItem,
                        dropdownIndex) in cineClassificationList"
                        :key="dropdownIndex"
                        @click="
                          onDropdownChange(
                            $event,
                            item.label,
                            dropdownItem,
                            index
                          )
                        "
                        >{{
                          dropdownItem.cine_classification_name
                        }}</b-dropdown-item
                      >
                    </b-dropdown>
                    <!-- <Tooltip :title="$t(item.tooltip)" /> -->
                  </div>
                  <p class="error_message">
                    <!-- <span
                v-if="submitted && item.dropdownSelected.length == 0"
              >Please Select Location Type.</span>-->
                  </p>
                </div>

                <!-- TIER DROPDOWN -->
                <div
                  class="dropdown-curve-container"
                  v-if="item.fieldname === 'tier_type_id'"
                >
                  <div class="d-flex justify-content-center align-items-center">
                    <label
                      :class="
                        item.dropdownSelected &&
                        item.dropdownSelected.length > 0
                          ? 'shift-up'
                          : ''
                      "
                      >{{ $tc(item.label, 1) }}</label
                    >
                    <b-dropdown
                      :text="item.dropdownSelected"
                      variant="dropdown-curve"
                      class="w-100"
                      name="tier_type"
                      id="tier_type"
                    >
                      <b-dropdown-item
                        v-for="(dropdownItem, dropdownIndex) in tierTypeList"
                        :key="dropdownIndex"
                        @click="
                          onDropdownChange(
                            $event,
                            item.label,
                            dropdownItem,
                            index
                          )
                        "
                        >{{ dropdownItem.tier_type_name }}</b-dropdown-item
                      >
                    </b-dropdown>
                    <!-- <Tooltip :title="$t(item.tooltip)" /> -->
                  </div>
                  <p class="error_message">
                    <!-- <span
                v-if="submitted && item.dropdownSelected.length == 0"
              >Please Select Location Type.</span>-->
                  </p>
                </div>

                <div
                  class="dropdown-curve-container"
                  v-if="item.fieldname === 'preferred_language_id'"
                >
                  <div class="d-flex justify-content-center align-items-center">
                    <label
                      :class="
                        item.dropdownSelected &&
                        item.dropdownSelected.length > 0
                          ? 'shift-up'
                          : ''
                      "
                      >{{ $tc(item.label, 1) }}</label
                    >
                    <multiselect
                      :options="ActiveLanguages"
                      v-model="selectedPreferredLang"
                      :searchable="true"
                      label="lang_name"
                      track-by="lang_id"
                      placeholder="."
                      @input="
                        onDropdownChange(
                          $event,
                          item.label,
                          selectedPreferredLang,
                          index
                        )
                      "
                      :allowEmpty="false"
                      :showLabels="false"
                    ></multiselect>
                  </div>
                  <p class="error_message">
                    <span v-if="submitted && item.dropdownSelected.length == 0"
                      >Please Select Preferred Language.</span
                    >
                  </p>
                </div>
              </div>

              <!-- CUSTOM FIELDS SECTION -->
              <section class="mb-4 col-12" v-if="custom_fields_list.length > 0">
                <div class="section-title mb-4">Custom Field</div>
                <form v-if="custom_fields_list" class="row">
                  <div
                    v-for="(field, fieldKey) in custom_fields_list"
                    :key="fieldKey"
                    class="col-lg-4 col-xl-3 mb-4"
                  >
                    <div v-if="field.custom_field_type == 'text'">
                      <div class="d-flex align-items-center">
                        <div class="input-material">
                          <input
                            :minlength="field.min_length"
                            :maxlength="field.max_length"
                            type="text"
                            name="text_input"
                            v-model="input_data[fieldKey]"
                            placeholder="."
                          />
                          <label
                            :class="
                              input_data[fieldKey] !== undefined &&
                              input_data[fieldKey].length > 0
                                ? 'shift-up'
                                : ''
                            "
                            >{{ field.custom_field_name }}</label
                          >
                        </div>
                      </div>
                      <p class="error_message">
                        <span
                          v-if="
                            (input_data[fieldKey] === undefined ||
                              input_data[fieldKey] == '') &&
                              field.field_is_required == 'Y'
                          "
                          >Please Select {{ field.custom_field_name }}</span
                        >
                      </p>
                    </div>
                    <div v-if="field.custom_field_type == 'textarea'">
                      <div class="d-flex align-items-center">
                        <div class="input-material-textarea">
                          <textarea
                            :minlength="field.min_length"
                            :maxlength="field.max_length"
                            name="text_area"
                            v-model="input_data[fieldKey]"
                          ></textarea>
                          <label
                            :class="
                              input_data[fieldKey] != undefined &&
                              input_data[fieldKey].length > 0
                                ? 'shift-up'
                                : ''
                            "
                            >{{ field.custom_field_name }}</label
                          >
                        </div>
                      </div>
                      <p class="error_message">
                        <span
                          v-if="
                            (input_data[fieldKey] === undefined ||
                              input_data[fieldKey] == '') &&
                              field.field_is_required == 'Y'
                          "
                          >Please Select {{ field.custom_field_name }}</span
                        >
                      </p>
                    </div>
                    <div v-if="field.custom_field_type == 'number'">
                      <div class="d-flex align-items-center">
                        <div class="input-material">
                          <input
                            type="number"
                            :minlength="field.min_length"
                            :maxlength="field.max_length"
                            name="number"
                            :placeholder="field.custom_field_name"
                            v-model="input_data[fieldKey]"
                          />
                          <label
                            :class="
                              input_data[fieldKey] != undefined &&
                              input_data[fieldKey].length > 0
                                ? 'shift-up'
                                : ''
                            "
                            >{{ field.custom_field_name }}</label
                          >
                        </div>
                      </div>
                      <p class="error_message">
                        <span
                          v-if="
                            (input_data[fieldKey] === undefined ||
                              input_data[fieldKey] == '') &&
                              field.field_is_required == 'Y'
                          "
                          >Please Select {{ field.custom_field_name }}</span
                        >
                      </p>
                    </div>
                    <div
                      v-if="field.custom_field_type == 'checkbox'"
                      class="d-flex align-items-center"
                    >
                      <label class="mr-2">{{ field.custom_field_name }}</label>
                      <b-form-checkbox
                        name="check-button"
                        switch
                        v-model="input_data[fieldKey]"
                      ></b-form-checkbox>
                    </div>

                    <div
                      v-if="field.custom_field_type == 'rating'"
                      class="d-flex align-items-center"
                    >
                      <label class="mr-2">{{ field.custom_field_name }}</label>
                      <star-rating v-model="rating"></star-rating>
                    </div>

                    <!-- <p class="error_message">{{errorMessage}}</p> -->
                  </div>

                  <!-- <div class="col-md-12 text-center">
              <button @click.prevent.stop="submit" class="btn-blue">{{ $t('submit') }}</button>
            </div>-->
                </form>
              </section>
            </div>
          </b-collapse>
        </section>

        <!-- end -->
        <section class="my-3 w-100 px-3 distributor-section-new">
          <div
            class="section-title d-flex justify-content-between section-border section-border"
            v-b-toggle.transalations
            style="padding: 6px; align-items: center"
          >
            <span class="fs">
              {{ "Translations" }}
            </span>
            <button type="button" class="btn-transparent chevron">
              <img
                src="@/assets/img/icons/primary/chevron-down.svg"
                height="24"
                width="24"
              />
            </button>
          </div>
          <b-collapse
            id="transalations"
            class="mt-2 translationContainer"
            v-model="sectionCollapse.transalations"
          >
            <div class="bn-tabs-nav">
              <button
                v-for="(content, contentIndex) in langContent"
                :key="contentIndex"
                :class="[
                  'btn-tab-title ',
                  { active: contentIndex == activeClass },
                ]"
                @click.prevent.stop="onChangeTabHandler($event, contentIndex)"
              >
                <strong>
                  <span
                    :class="
                      content.langauge.toLowerCase() !== 'english'
                        ? notempty[contentIndex]
                          ? ''
                          : 'text-danger'
                        : ''
                    "
                    >{{ content.langauge }}</span
                  >
                </strong>
              </button>
            </div>

            <div class="bn-tabs-content p-3">
              <div
                v-for="(content, contentIndex) in langContent"
                :key="contentIndex"
              >
                <div v-if="contentIndex === activeClass">
                  <div class="row">
                    <div class="col-md-4">
                      <div class="d-flex align-items-center">
                        <div class="input-material">
                          <input
                            v-model="content.cinema_name"
                            placeholder="."
                            name="cinema_name"
                            id="cinema_name"
                            maxlength="200"
                            @input="
                              onChangeTranslationInput(
                                $event,
                                content,
                                'cine_name',
                                contentIndex
                              )
                            "
                          />
                          <label :class="content.cinema_name ? 'shift-up' : ''"
                            >Cinema Name</label
                          >
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="d-flex align-items-center">
                        <div class="input-material">
                          <input
                            v-model="content.cinema_address"
                            placeholder="."
                            name="cinema_name"
                            id="cinema_name"
                            maxlength="200"
                            @input="
                              onChangeTranslationInput(
                                $event,
                                content,
                                'cine_address',
                                contentIndex
                              )
                            "
                          />
                          <label
                            :class="content.cinema_address ? 'shift-up' : ''"
                            >Cinema Address</label
                          >
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="d-flex align-items-center">
                        <div class="input-material">
                          <input
                            v-model="content.cinema_location"
                            placeholder="."
                            name="cinema_name"
                            id="cinema_name"
                            maxlength="200"
                            @input="
                              onChangeTranslationInput(
                                $event,
                                content,
                                'cine_location',
                                contentIndex
                              )
                            "
                          />
                          <label
                            :class="content.cinema_location ? 'shift-up' : ''"
                            >Cinema Location</label
                          >
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4 mt-2">
                      <div class="d-flex align-items-center">
                        <div class="input-material">
                          <input
                            v-model="content.company_name"
                            placeholder="."
                            name="company_name"
                            id="company_name"
                            maxlength="200"
                            @input="
                              onChangeTranslationInput(
                                $event,
                                content,
                                'company_name',
                                contentIndex
                              )
                            "
                          />
                          <label :class="content.company_name ? 'shift-up' : ''"
                            >Company Name</label
                          >
                        </div>
                      </div>
                    </div>
                    <div
                      class="col-lg-12 align-self-center mb-4 descriptionEditor"
                    >
                      <div
                        class="descriptionSection font-weight-bold fs-14 mb-3"
                      >
                        Description
                      </div>
                      <div class=" " v-if="content.isEdit">
                        <vue-editor
                          v-model="content.cinema_description"
                          name="page"
                          id="page"
                        ></vue-editor>
                      </div>
                      <div
                        class="input-material-textarea"
                        v-else-if="content.isEditHtml && !content.isEdit"
                      >
                        <textarea
                          id="htmlContent"
                          name="htmlContent"
                          v-model="content.cinema_description"
                          placeholder="Description"
                          class="htmlContent"
                        />
                      </div>
                      <div class="ql-snow" v-else>
                        <div
                          class="ql-editor"
                          v-html="content.cinema_description"
                          v-if="content.cinema_description"
                        ></div>
                        <div
                          class="ql-editor text-center"
                          v-else
                          style="min-height: 33px"
                        >
                          No Content
                        </div>
                      </div>
                      <vue-editor style="display: none" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-collapse>
        </section>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            @click.prevent.stop="onUpdateHandler"
            class="btn-blue"
          >
            {{ $t("update") }}
          </button>
          <!-- <button class="btn-black">{{ $t('reset') }}</button> -->
          <b-button class="btn-outline-grey" variant="default" to="cinemas">{{
            $t("cancel")
          }}</b-button>
        </div>
      </form>
    </div>

    <b-modal
      title="Cinema Image"
      hide-footer
      ref="preview-modal"
      id="selected-image-preview-modal"
    >
      <img :src="_GetImagePath(Cinemas[30].fieldvalue)" class="img-fluid" />
    </b-modal>

    <b-modal id="imagecropper" hide-header hide-footer no-close-on-backdrop>
      <label class="h4 text-center">Crop Image</label>
      <button
        class="btn-clearDate float-right"
        v-on:click="hideCropperModal('imagecropper')"
      >
        ✖
      </button>
      <vue-cropper
        ref="cropper"
        :src="imgSrc"
        :viewMode="1"
        :autoCrop="true"
        :autoCropWidth="350"
        :autoCropHeight="220"
        :cropBoxResizable="true"
        dragMode="none"
        alt="Source Image"
        preview=".preview"
      ></vue-cropper>
      <!-- aspectratiot:175/175 -->
      <br />
      <div class="text-center">
        <button class="btn-blue" @click.prevent.stop="cropImage">Save</button>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import MasterService from "@/services/MasterService";
  import MovieService from "@/services/MovieService";
  import Cinemas from "@/helper/formJSONMaster/Cinemas";
  import CinemaService from "@/services/CinemasService";
  import VueCropper from "vue-cropperjs";
  import "cropperjs/dist/cropper.css";
  import ExhibitorService from "@/services/ExhibitorService";
  import { VueEditor } from "vue2-editor";
  import _ from "lodash";

  export default {
    components: { VueCropper, VueEditor },
    data() {
      return {
        sectionCollapse: {
          transalations: true,
          cinemadetails: true,
        },
        langContent: [],
        Languages: [],
        ContentLanguages: [],
        activeClass: 0,
        notempty: [false, false, false, false, false, false],
        btenable: false,
        Cinemas: Cinemas.ms_cinemas,
        Methods: Cinemas.Methods,
        submitted: false,
        isDisabled: false,
        countryList: [],
        stateList: [],
        cityList: [],
        orgList: [],
        currencyList: [],
        regionList: [],
        cinemaTypesList: [],
        territoryList: [],
        locationTypesList: [],
        cineClassificationList: [],
        tierTypeList: [],
        custom_fields_list: [],
        input_data: [],
        selected_country: null,
        selected_state: null,
        selected_city: null,
        file: "",
        imgSrc: "",
        cropImg: "",
        filename: "",
        indexofthubmnail: "",
        SelectedCountryCode: "Code",
        CodeListCopy: [],
        ActiveLanguages: [],
        selectedPreferredLang: null,
        searchCode: "",
      };
    },
    beforeMount() {
      const { id } = this.$route.query;
      if (id) {
        this.getEditList(id);
        this.getCustomFields(id);
        this.isDisabled =
          this.secureStore.get("USINFO") &&
          this.secureStore.get("USINFO")["role_id"] &&
          this.secureStore.get("USINFO")["role_id"] === 1
            ? false
            : true;
      } else {
        this.$router.go(-1);
      }
    },
    mounted() {},
    methods: {
      CheckEmptyContent: function(content, langIndex) {
        if (
          content.cinema_name &&
          content.cinema_address &&
          content.cinema_location &&
          content.company_name
        ) {
          this.notempty[langIndex] = true;
        } else {
          this.notempty[langIndex] = false;
        }
      },
      onChangeInput(event, item) {
        let index =
          this.langContent.findIndex(
            (x) => x.langauge.toLowerCase() == "english"
          ) || 0;
        if (item.fieldname == "cine_name") {
          this.langContent[index].cinema_name = event.target.value;
        } else if (item.fieldname == "cine_address") {
          this.langContent[index].cinema_address = event.target.value;
        } else if (item.fieldname == "cine_location") {
          this.langContent[index].cinema_location = event.target.value;
        } else if (item.fieldname == "company_name") {
          this.langContent[index].company_name = event.target.value;
        }
      },
      onChangeTranslationInput(event, content, item, contentIndex) {
        let index =
          this.Cinemas.findIndex((x) => x.fieldname.toLowerCase() == item) || 0;
        if (index && content.langauge.toLowerCase() == "english") {
          this.Cinemas[index].fieldvalue = event.target.value;
        }
        this.CheckEmptyContent(content, contentIndex);
      },
      onChangeTabHandler: function(event, index) {
        this.activeClass = index;
      },
      getContentLanguage: function(Content) {
        MovieService.GetMovieContentLanguages()
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              if (data.ContentLanguages.length > 0) {
                this.ContentLanguages = data.ContentLanguages;
              }
            } else {
              console.log("data.message :", data.message);
            }
            return;
          })
          .then(() => {
            this.makeLangContainers(Content);
          })
          .catch((error) => {});
      },
      makeLangContainers: function(Content) {
        console.log("Content", Content);
        console.log("this.ContentLanguages", this.ContentLanguages);
        this.ContentLanguages.map((x, i) => {
          let Array1 = [];
          if (Content && Content.length > 0) {
            Array1 = Content.filter((y) => {
              return y.langaugeId == x.langaugeId;
            });
          }

          console.log("Array1", Array1);
          if (Array1.length > 0) {
            x["cinema_name"] = Array1[0].cinema_name;
            x["cinema_address"] = Array1[0].cinema_address;
            x["cinema_location"] = Array1[0].cinema_location;
            x["company_name"] = Array1[0].company_name;
            x["cinema_description"] = _.unescape(Array1[0].cinema_description || "");
            x["isEdit"] = true;
            x["isEditHtml"] = false;
            if (
              Array1[0].cinema_name &&
              Array1[0].cinema_address &&
              Array1[0].cinema_location
            ) {
              this.notempty[i] = true;
            }
          } else {
            x["cinema_name"] = "";
            x["cinema_address"] = "";
            x["cinema_location"] = "";
            x["company_name"] = "";
            x["cinema_description"] = "";
            x["isEdit"] = true;
            x["isEditHtml"] = false;
          }
        });
        this.langContent = this.ContentLanguages;
        console.log("this.langContent", this.langContent);
      },
      showImage: function() {
        this.$refs["preview-modal"].show();
      },
      hideCropperModal: function(modal) {
        this.$bvModal.hide("imagecropper");
      },
      setImage: function(e, index) {
        this.file = e.target.files[0];
        this.filename = e.target.files[0]["name"];
        this.indexofthubmnail = index;

        if (this.file.type.indexOf("image/") === -1) {
          this.$toasted.show("Please select an image file");
          return;
        }
        if (typeof FileReader === "function") {
          const reader = new FileReader();
          reader.onload = (event) => {
            this.imgSrc = event.target.result;
            this.$bvModal.show("imagecropper");
            e.target.value = "";
          };
          reader.readAsDataURL(this.file);
        } else {
          // alert("Sorry, FileReader API not supported");
        }
      },
      cropImage() {
        this.$bvModal.hide("imagecropper");
        // get image data for post processing, e.g. upload or setting image src
        this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
        // this.data = JSON.stringify(this.$refs.cropper.getData(), null, 4);
        var block = this.cropImg.split(";");
        // Get the content type of the image
        var contentType = block[0].split(":")[1]; // In this case "image/gif"
        // get the real base64 content of the file
        var realData = block[1].split(",")[1]; // In this case "R0lGODlhPQBEAPeoAJosM...."
        // Convert it to a blob to upload
        var blob1 = this.b64toBlob(realData, contentType);
        this.onThumbnailUpload(blob1, this.filename, this.indexofthubmnail);
      },

      b64toBlob(b64Data, contentType, sliceSize) {
        contentType = contentType || "";
        sliceSize = sliceSize || 512;

        var byteCharacters = atob(b64Data);
        var byteArrays = [];

        for (
          var offset = 0;
          offset < byteCharacters.length;
          offset += sliceSize
        ) {
          var slice = byteCharacters.slice(offset, offset + sliceSize);

          var byteNumbers = new Array(slice.length);
          for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }

          var byteArray = new Uint8Array(byteNumbers);

          byteArrays.push(byteArray);
        }

        var blob = new Blob(byteArrays, { type: contentType });
        return blob;
      },
      onThumbnailUpload: function(image, filename, index) {
        let loader = this.$loading.show();

        let formData = new FormData();
        // formData.append("image", image);
        formData.append("image", image, filename);
        formData.append("imagePath", "Cinema Image");
        MasterService.GlobalUploadImage(formData)
          .then((response) => {
            // console.log("response :", response);
            const { data } = response;
            if (data && data.status) {
              this.Cinemas[index].fieldvalue = data.path;
              this.imgSrc = "";
              this.$bvModal.hide("imagecropper");
            } else {
              data["message"] && data["message"]["message"]
                ? this.$toasted.show(data.message.message)
                : this.$toasted.show(
                    data.message ||
                      "Sorry! Something went wrong. kindly contact your administrator"
                  );
            }
          })
          .catch(this._CatchError)
          .finally(() => {
            setTimeout(() => loader.hide(), 1000);
          });
      },
      // getCustomFields: function(cinema_id) {
      //   let payload = {
      //     table_name: "ms_cinemas",
      //     table_item_id: cinema_id
      //   };
      //   MasterService.getCustomFieldValue(payload)
      //     .then(response => {
      //       const { data } = response;
      //       if (data.status && data.Records.length > 0) {
      //         this.custom_fields_list = _.sortBy(data.Records, ["order_id"]);
      //         this.custom_fields_list.map(x => {
      //           this.input_data.push(
      //             x.custom_field_data == "Yes"
      //               ? true
      //               : x.custom_field_data == "No"
      //               ? false
      //               : x.custom_field_data
      //           );
      //         });
      //         console.log("this.input_data :>> ", this.input_data);
      //       } else {
      //         let payload2 = {
      //     table_name: "ms_cinemas"
      //   };
      //   MasterService.getCustomFields(payload2)
      //     .then(response => {
      //       const { data } = response;
      //       if (data.status && data.Records.length > 0) {
      //         this.custom_fields_list = _.sortBy(data.Records, ["order_id"]);
      //         this.custom_fields_list.map((field, index) => {
      //           if (field.custom_field_type == "checkbox") {
      //             this.input_data[index] =
      //               this.input_data[index] == undefined
      //                 ? false
      //                 : this.input_data[index];
      //           }
      //         });
      //         console.log(
      //           "this.custom_fields_list :>> ",
      //           this.custom_fields_list
      //         );
      //       } else {
      //         // Show Errors
      //         this.$toasted.show(data.message);
      //       }
      //     })
      //     .catch(error => {
      //       // Show Catch Error
      //       console.log("show error :", error);
      //     });
      //       }
      //     })
      //     .catch(error => {
      //       // Show Catch Error
      //       console.log("show error :", error);
      //     });
      // },
      getCustomFields: async function(cinema_id) {
        let payload2 = {
          table_name: "ms_cinemas",
        };
        MasterService.getCustomFields(payload2)
          .then(async (response) => {
            const { data } = await response;
            if (data.status && data.Records.length > 0) {
              this.custom_fields_list = _.sortBy(data.Records, ["order_id"]);
              // this.custom_fields_list.map((field, index) => {
              //   if (field.custom_field_type == "checkbox") {
              //     this.input_data[index] =
              //       this.input_data[index] == undefined
              //         ? false
              //         : this.input_data[index];
              //   }
              // });

              let payload = {
                table_name: "ms_cinemas",
                table_item_id: cinema_id,
              };
              MasterService.getCustomFieldValue(payload)
                .then((response) => {
                  const { data } = response;
                  if (data.status && data.Records.length > 0) {
                    console.log("data.Records :>> ", data.Records);
                    data.Records = _.sortBy(data.Records, ["order_id"]);
                    data.Records.map((x) => {
                      this.input_data.push(
                        x.custom_field_data == "Yes"
                          ? true
                          : x.custom_field_data == "No"
                          ? false
                          : x.custom_field_data
                      );
                    });
                    console.log(
                      "this.custom_fields_list :>> ",
                      this.custom_fields_list
                    );
                    console.log("this.input_data :>> ", this.input_data);
                  } else {
                  }
                })
                .catch((error) => {
                  // Show Catch Error
                  console.log("show error :", error);
                });
            } else {
              // Show Errors
              // this.$toasted.show(data.message);
            }
          })
          .catch((error) => {
            // Show Catch Error
            console.log("show error :", error);
          });
      },
      onSelectHandler(type, value, index) {
        if (type == "countrycode") {
          this.SelectedCountryCode = value.country_mob_code;
        }
      },
      onSearchCode() {
        if (this.searchCode && this.searchCode.length > 0) {
          this.countryList = this.CodeListCopy.filter((x) => {
            if (
              x.country_mob_code &&
              x.country_mob_code
                .toLowerCase()
                .includes(this.searchCode.toLowerCase())
            ) {
              return x;
            }
          });
        } else {
          this.countryList = this.CodeListCopy;
        }
      },
      onFocusHandler: function() {
        // this.submitted = false;
      },
      getEditList: function(id) {
        let transalationContent = [];
        // let params = `id`
        // this.secureStore.get("USINFO").role_id;
        // console.log(
        //   "this.secureStore.get(editcinme) :",
        //   this.secureStore.get("USINFO").role_id
        // );
        let body = this.getRequestBody("GET", undefined, {
          ...this.Methods,
          params: { id },
        });
        MasterService.GlobalRequest(body)
          .then((response) => {
            const { data } = response;
            if (data.status) {
              let obj = data.details[0];
              console.log("obj :>> ", obj);
              // console.log("obj :", obj);
              this.Cinemas.map((x, index) => {
                if (x.type === "radio") {
                  x.fieldvalue = obj[x.fieldname] === "Y" ? true : false;
                } else if (x.type === "date") {
                  x.fieldvalue = this.formatDate(obj[x.fieldname]);
                } else if (x.type === "dropdown") {
                  x.fieldvalue = obj[x.fieldname];
                  // x.dropdownSelected = obj[x.fieldname];
                } else {
                  x.fieldvalue = obj[x.fieldname];
                }
              });
              transalationContent = JSON.parse(obj.translation_data);
              console.log("this.Cinemas :>> ", this.Cinemas);
              this.getCurrencyList(obj["currency_id"]);
              this.getOrgList(obj["org_id"]);
              this.getCountryList(obj["country_id"]);
              this.getStateList(obj["state_id"], obj["country_id"]);
              this.getCityList(obj["city_id"], obj["state_id"]);
              this.getRegions(obj["region_id"]);
              this.getCinemaTypes(obj["cinema_type_id"]);
              // this.getTerritories(obj["territory_id"]);
              this.getTerritoryData(obj["territory_id"]);
              this.getLocationTypes(obj["location_type_id"]);
              this.getCineClassification(obj["cinema_classification_id"]);
              this.getTierType(obj["tier_type_id"]);
              this.getActiveLanguages();
              this.SelectedCountryCode =
                obj.cine_mobile_code == null ? "Code" : obj.cine_mobile_code;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError)
          .finally(() => {
            this.getContentLanguage(transalationContent);
          }); //message
      },
      getOrgList: function(uniqueId) {
        // let body = this.getRequestBody("GET", undefined, {
        //   GET: "/admin/",
        //   tableName: "organizations"
        // });
        // MasterService.GlobalRequest(body)
        let payload = {
          tableName: "organizations",
          org_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.orgList = data.Records;
              this.setNestedDropdownFields("org_id", uniqueId, data.Records);
            } else {
              console.log("show error :", data.message);
              // this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      },
      getCountryList: function(uniqueId) {
        this.stateList = [];
        this.countryList = [];
        this.cityList = [];
        let payload = {
          tableName: "ms_countries",
          country_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.countryList = data.Records;
              this.CodeListCopy = data.Records;
              this.setNestedDropdownFields(
                "country_id",
                uniqueId,
                data.Records
              );
            } else {
              console.log("show error :", data.message);
              // this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      },
      getStateList: function(uniqueId, countryId) {
        if (countryId) {
          this.stateList = [];
          this.cityList = [];
          let payload = {
            tableName: "ms_states",
            state_is_active: "Y",
            country_id: countryId,
          };
          MasterService.GetActiveList(payload)
            .then((response) => {
              const { data } = response;
              if (data.status && data.Records.length > 0) {
                this.stateList = data.Records;
                if (uniqueId) {
                  this.setNestedDropdownFields(
                    "state_id",
                    uniqueId,
                    data.Records
                  );
                }
              } else {
                console.log("show error :", data.message);
                // this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError); //message
        }
      },
      getCityList: function(uniqueId, stateId) {
        this.cityList = [];
        let payload = {
          tableName: "ms_cities",
          city_is_active: "Y",
          state_id: stateId,
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.cityList = data.Records;
              if (uniqueId) {
                this.setNestedDropdownFields("city_id", uniqueId, data.Records);
              }
            } else {
              console.log("show error :", data.message);
              // this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },

      getRegions: function(uniqueId) {
        let payload = {
          tableName: "ms_regions",
          region_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status) {
              if (data.Records && data.Records.length > 0) {
                this.regionList = data.Records;
                this.setNestedDropdownFields(
                  "region_id",
                  uniqueId,
                  data.Records
                );
              }
            } else {
              console.log("show error :", data.message);
              // this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },
      getCinemaTypes: function(uniqueId) {
        let payload = {
          tableName: "ms_cinema_types",
          cine_type_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.cinemaTypesList = data.Records;

              this.setNestedDropdownFields(
                "cinema_type_id",
                uniqueId,
                data.Records
              );
            } else {
              console.log("show error1 :", data.message);
              // this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },
      // getTerritories: function (uniqueId) {
      //   let payload = {
      //     tableName: "ms_territories",
      //     territory_is_active: "Y",
      //   };
      //   MasterService.GetActiveList(payload)
      //     .then((response) => {
      //       const { data } = response;
      //       if (data.status && data.Records.length > 0) {
      //         this.territoryList = data.Records;

      //         this.setNestedDropdownFields(
      //           "territory_id",
      //           uniqueId,
      //           data.Records
      //         );
      //       } else {
      //         console.log("show error1 :", data.message);
      //         // this.$toasted.show(data.message);
      //       }
      //     })
      //     .catch(this._CatchError);
      // },
      getTerritoryData(uniqueId) {
        let payload = {
          territory_is_active: "Y",
        };
        ExhibitorService.GetTerritoryData(payload)
          .then((response) => {
            const { data } = response;

            if (data.Records.length > 0) {
              console.log(data.Records);
              let territoryData = data.Records;
              this.territoryList = territoryData;
              this.setNestedDropdownFields(
                "territory_id",
                uniqueId,
                data.Records
              );
            } else {
              this.territoryList = [];
            }
          })
          .catch((error) => {
            console.log(error);
          });
      },
      getLocationTypes: function(uniqueId) {
        let payload = {
          tableName: "ms_location_types",
          location_type_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.locationTypesList = data.Records;

              this.setNestedDropdownFields(
                "location_type_id",
                uniqueId,
                data.Records
              );
            } else {
              console.log("show error :", data.message);
              // this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },
      getCineClassification: function(uniqueId) {
        let payload = {
          tableName: "ms_cinema_classification",
          cine_classification_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.cineClassificationList = data.Records;
              this.setNestedDropdownFields(
                "cinema_classification_id",
                uniqueId,
                data.Records
              );
            } else {
              console.log("show error :", data.message);
              // this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },
      getTierType: function(uniqueId) {
        let payload = {
          tableName: "ms_tier_type",
          tier_type_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.tierTypeList = data.Records;
              this.setNestedDropdownFields(
                "tier_type_id",
                uniqueId,
                data.Records
              );
            } else {
              console.log("show error :", data.message);
              // this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },
      getCurrencyList: function(uniqueId) {
        this.currencyList = [];
        let payload = {
          tableName: "ms_currencies",
          curr_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.currencyList = data.Records;
              this.setNestedDropdownFields(
                "currency_id",
                uniqueId,
                data.Records
              );
              // this.currencyList.filter(x => {
              //   if (x.curr_id === value) {
              //     this.Cinemas[index].dropdownSelected = x.curr_code;
              //   }
              // });
            } else {
              console.log("show error :", data.message);
              // this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },
      findLangObj() {
        console.log("coming to findLangObj: this.Cinemas", this.Cinemas);
        console.log(
          "coming to findLangObj: this.ActiveLanguages",
          this.ActiveLanguages
        );
        let lang_obj = this.Cinemas.find(
          (x) => x.fieldname === "preferred_language_id"
        );
        console.log("coming to findLangObj: lang_obj", lang_obj);
        console.log(
          "coming to findLangObj: lang_obj.fieldvalue",
          lang_obj.fieldvalue
        );
        if (
          this.ActiveLanguages &&
          this.ActiveLanguages.length > 0 &&
          lang_obj &&
          lang_obj.fieldvalue
        ) {
          let lang = this.ActiveLanguages.find(
            (l) => l.lang_id == lang_obj.fieldvalue
          );
          console.log("coming to findLangObj: lang", lang);
          if (lang) {
            this.selectedPreferredLang = lang;
            lang_obj.dropdownSelected = lang.lang_name;
            console.log(
              "coming to findLangObj: this.selectedPreferredLang",
              this.selectedPreferredLang
            );
          }
        }
      },
      setCityHandler: function(cityId) {
        this.Cinenams.map((y) => {
          if (y.fieldname === "city_id") {
            if (cityId) {
              this.cityList.map((x) => {
                if (cityId && x.city_id === cityId) {
                  y.dropdownSelected = x.city_name;
                }
              });
            } else {
              y.dropdownSelected = "Select State";
              y.fieldvalue = "";
            }
          }
        });
      },
      setDropdownHandler: function(resetList) {
        this.Cinemas.map((y) => {
          let array = resetList.filter((x) => `${x}_id` == y.fieldname);
          if (array.length > 0) {
            y.dropdownSelected = `Select ${array[0]}`;
            y.fieldvalue = "";
          }
        });
      },
      onDropdownChange: function(event, type, item, mainIndex) {
        if (type === "country") {
          this.Cinemas[mainIndex].fieldvalue = item.country_id;
          this.Cinemas[mainIndex].dropdownSelected = item.country_name;
          this.Cinemas[mainIndex + 1].dropdownSelected = "";

          this.selected_state = null;
          this.selected_city = null;
          this.getStateList(null, item.country_id);
          this.setDropdownHandler(["state", "city"]);
        } else if (type === "state") {
          this.Cinemas[mainIndex].dropdownSelected = item.state_name;
          this.Cinemas[mainIndex].fieldvalue = item.state_id;

          this.selected_city = null;
          this.getCityList(null, item.state_id);
          this.setDropdownHandler(["city"]);
        } else if (type === "city") {
          this.Cinemas[mainIndex].dropdownSelected = item.city_name;
          this.Cinemas[mainIndex].fieldvalue = item.city_id;
        } else if (type === "currency") {
          this.Cinemas[mainIndex].dropdownSelected = item.curr_code;
          this.Cinemas[mainIndex].fieldvalue = item.curr_id;
        } else if (type === "organaization") {
          this.Cinemas[mainIndex].dropdownSelected = item.city_name;
          this.Cinemas[mainIndex].fieldvalue = item.city_id;
        } else if (type === "territory") {
          this.Cinemas[mainIndex].dropdownSelected = item.territory_name;
          this.Cinemas[mainIndex].fieldvalue = item.territory_id;
        } else if (type === "region") {
          this.Cinemas[mainIndex].dropdownSelected = item.region_name;
          this.Cinemas[mainIndex].fieldvalue = item.region_id;
        } else if (type === "cinema_type") {
          this.Cinemas[mainIndex].dropdownSelected = item.cinema_type_name;
          this.Cinemas[mainIndex].fieldvalue = item.cinema_type_id;
        } else if (type === "cinema_classification") {
          this.Cinemas[mainIndex].dropdownSelected =
            item.cine_classification_name;
          this.Cinemas[mainIndex].fieldvalue = item.cinema_classification_id;
        } else if (type === "tier_type") {
          this.Cinemas[mainIndex].dropdownSelected = item.tier_type_name;
          this.Cinemas[mainIndex].fieldvalue = item.tier_type_id;
        } else if (type === "location_type") {
          this.Cinemas[mainIndex].dropdownSelected = item.location_type_name;
          this.Cinemas[mainIndex].fieldvalue = item.location_type_id;
        } else if (type === "preferred_language_id") {
          this.Cinemas[mainIndex].dropdownSelected = item.lang_name;
          this.Cinemas[mainIndex].fieldvalue = item.lang_id;
        }
      },
      setNestedDropdownFields: function(name, id, array) {
        let filterObj = id
          ? array.filter((x) =>
              name == "currency_id" ? x["curr_id"] === id : x[name] === id
            )
          : null;
        if (name == "country_id") {
          this.selected_country = filterObj;
        } else if (name == "state_id") {
          this.selected_state = filterObj;
        } else if (name == "city_id") {
          this.selected_city = filterObj;
        }
        this.Cinemas.map((x) => {
          if (name == "country_id" && name === x.fieldname) {
            x.dropdownSelected = filterObj ? filterObj[0].country_name : "";
          } else if (name == "state_id" && name === x.fieldname) {
            x.dropdownSelected = filterObj ? filterObj[0].state_name : "";
          } else if (name == "city_id" && name === x.fieldname) {
            x.dropdownSelected = filterObj ? filterObj[0].city_name : "";
          } else if (name == "currency_id" && name === x.fieldname) {
            x.dropdownSelected = filterObj
              ? filterObj[0].curr_code
              : "Select Currency";
          } else if (name == "org_id" && name === x.fieldname) {
            x.dropdownSelected = filterObj
              ? filterObj[0].org_name
              : "Select Organization";
          } else if (name == "cinema_type_id" && name === x.fieldname) {
            x.dropdownSelected = filterObj ? filterObj[0].cinema_type_name : "";
          } else if (name == "location_type_id" && name === x.fieldname) {
            x.dropdownSelected = filterObj
              ? filterObj[0].location_type_name
              : "";
          } else if (name == "territory_id" && name === x.fieldname) {
            x.dropdownSelected = filterObj ? filterObj[0].territory_name : "";
          } else if (name == "region_id" && name === x.fieldname) {
            x.dropdownSelected = filterObj ? filterObj[0].region_name : "";
          } else if (
            name == "cinema_classification_id" &&
            name === x.fieldname
          ) {
            x.dropdownSelected = filterObj
              ? filterObj[0].cine_classification_name
              : "";
          } else if (name == "tier_type_id" && name === x.fieldname) {
            x.dropdownSelected = filterObj ? filterObj[0].tier_type_name : "";
          }
        });
      },
      getActiveLanguages() {
        let body = {
          tableName: "ms_language",
          lang_is_active: "Y",
        };
        MasterService.GetActiveList(body)
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              if (data.Records.length > 0) {
                this.ActiveLanguages = data.Records;
                this.findLangObj();
              }
            } else
              this.$toasted.show(data.message || "Opps! Something went wrong");
          })
          .catch(this._CatchError);
      },
      onUpdateHandler: function() {
        let flagcustomfield = true;
        let input = [];
        this.custom_fields_list.map((field, index) => {
          if (
            field.custom_field_type == "checkbox" &&
            (this.input_data[index] == undefined ||
              this.input_data[index] == "")
          ) {
            console.log("in here :>> ");
            this.input_data[index] = false;
          }
          if (field.field_is_required == "Y") {
            if (
              (this.input_data[index] == undefined ||
                this.input_data[index] == "") &&
              this.input_data[index] !== false
            ) {
              // this.errorMessage = "please fill in all required fields";
              this.$toasted.show("Enter Custom Field details");
              flagcustomfield = false;
              return;
            }
          }
        });
        this.submitted = true;
        this.$validator.validate().then((valid) => {
          if (valid) {
            if (flagcustomfield) {
              let loader = this.$loading.show();

              for (let i in this.custom_fields_list) {
                input.push({
                  custom_field_id: this.custom_fields_list[i].custom_field_id,
                  input_data: this.input_data[i],
                });
              }

              // this.langContent.forEach((x) => {
              //   x.cinema_description = _.unescape(x.cinema_description)
              // })
              // this.Cinemas.filter(x => {
              //   x.fieldvalue = x.fieldvalue == null ? "" : x.fieldvalue;
              // });
              // console.log("this.Cinemas zzzzz 1212:>> ", this.Cinemas);

              this.Cinemas.map((x) => {
                if (x.dropdownSelected == "") {
                  x.dropdownSelected = null;
                  x.fieldvalue = null;
                }
              });
              console.log("this.Cinemas zzzzz :>> ", this.Cinemas);
              this.btenable = true;
              let body = this.getRequestBody("PUT", this.Cinemas, {
                ...this.Methods,
                params: { id: this.$route.query.id },
              });
              body.payload["translation_data"] = JSON.stringify(
                this.langContent
              );
              body.payload.cine_mobile_code =
                this.SelectedCountryCode == "Code"
                  ? null
                  : this.SelectedCountryCode;
              console.log({ body });

              if (body.state_id === "") body.state_id = null;
              if (body.city_id === "") body.city_id = null;
              MasterService.GlobalRequest(body)
                .then(async (response) => {
                  this.btenable = false;
                  const { data } = response;
                  if (data.status) {
                    // console.log("here :", data);
                    // this.$router.push({
                    //   path: "/cinema-manager/cinemas"
                    // });
                    await CinemaService.UpdateCustomFieldValues({
                      custom_field_values: input,
                      table_id: this.$route.query.id,
                    })
                      .then(async (response) => {
                        loader.hide();
                        this.btenable = false;
                        const { data } = response;
                        if (data.status) {
                          this.$router.push({
                            path: "/cinema-manager/cinemas",
                          });
                        } else {
                          this.$toasted.show(data.message);
                        }
                      })
                      .catch(this._CatchError);
                  } else {
                    loader.hide();
                    this.$toasted.show(data.message);
                  }
                })
                .catch(this._CatchError); //message
            } else {
              this.$toasted.show("Please Enter Custom Field details");
            }
          }
        });
      },
    },
  };
</script>

<style>
  #imagecropper .btn-clearDate {
    margin-top: -10px;
    margin-right: -10px;
    font-size: 19px;
  }

  .translationContainer {
    background: rgba(211, 211, 211, 0.2);
    border-radius: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/CinemasComponents/editCinema.vue